import React from 'react';
import PreviewCompatibleImage from '../PreviewCompatibleImage';

export default ({ title, list }) => (
  <section className="section" style={{ background: '#28363d' }}>
    <div className="container">
      <div className="columns">
        <div className="column is-8">
          <h2 style={{ color: 'white', fontSize: '2rem', fontWeight: '500' }}>WHY CHOOSE US?</h2>
          <p style={{ color: 'rgb(83, 197, 209)' }}>{title}</p>
          <ul style={{ listStyleType: 'disc', paddingLeft: '2rem', color: '#fff' }}>
            {list.map((el, i) => (
              <li key={i} style={{ marginTop: '2rem' }}>
                <h3 style={{ color: '#fff', marginBottom: '1rem' }}>{el.title}</h3>
                <p style={{ color: 'rgb(83, 197, 209)' }}>{el.para}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className="column is-4" style={{ position: 'relative' }}>
          <div className="whychooseus_img">
            <PreviewCompatibleImage imageInfo={{ image: '/img/why_choose_us.png' }} />
          </div>
        </div>
      </div>
    </div>
  </section>
);
